import type { UseCase } from './use-case-step'

const PLACEHOLDER_BY_USE_CASE: Record<UseCase, { placeholder: string; heading: string; subheading: string }> = {
  'busy-professional': {
    heading: 'Anything you want us to skip?',
    subheading: 'Filter out noise so you only hear what matters to you.',
    placeholder: 'e.g. funding rounds, stock prices, crypto news, competitor drama...',
  },
  'student-learner': {
    heading: 'Topics to exclude?',
    subheading: 'Help us focus on what you need to learn, not distractions.',
    placeholder: 'e.g. political debates, celebrity news, opinion pieces...',
  },
  'curious-explorer': {
    heading: 'Anything you want to avoid?',
    subheading: 'Tell us what topics to skip so we can focus on what fascinates you.',
    placeholder: 'e.g. sports news, financial markets, technical jargon...',
  },
}

const DEFAULT_CONFIG = {
  heading: 'Anything you want us to avoid?',
  subheading: "Tell us what topics or keywords you'd like us to skip.",
  placeholder: 'e.g. funding rounds, Nvidia earnings, stock market, crypto prices...',
}

interface NegativeKeywordsStepProps {
  value: string
  useCase: UseCase | null
  onChange: (value: string) => void
}

export function NegativeKeywordsStep({ value, useCase, onChange }: NegativeKeywordsStepProps) {
  const config = useCase ? PLACEHOLDER_BY_USE_CASE[useCase] : DEFAULT_CONFIG

  return (
    <div>
      <h2 className="mb-2 text-3xl font-extrabold tracking-tight text-foreground">{config.heading}</h2>
      <p className="mb-8 text-base font-medium text-foreground/60">
        {config.subheading}
        <span className="ml-1 text-foreground/40">(Optional)</span>
      </p>

      <textarea
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={config.placeholder}
        className="w-full resize-none rounded-xl border border-black/10 bg-background p-4 text-foreground placeholder:text-foreground/30 focus:border-brand-500 focus:outline-none focus:ring-2 focus:ring-brand-500/20"
        rows={4}
        maxLength={1000}
      />
      <div className="mt-2 text-right">
        <span className="text-xs text-foreground/40">{value.length}/1000</span>
      </div>
    </div>
  )
}
